import { setProjectData } from './actions';
import { getBuyerProjectInfo } from '@/services/buyer-dashboard';
import { Dispatch } from 'redux';
import { IState } from '@/state/IState';

export const loadProjectData = (residentialUnitId?: number | null) => {
    return async function (dispatch: Dispatch, getState: () => IState): Promise<any> {
        // Seller context has no buyer.permissions slice, so the caller passes the unit id.
        const unitId = residentialUnitId ?? getState().buyer.permissions?.residentialUnitId;
        if (unitId == null) {
            return;
        }

        const data = await getBuyerProjectInfo(unitId);
        return dispatch(setProjectData(data));
    };
};
